import { useNavigate } from 'react-router-dom';
import { Button, Input, InputWrapperAuth } from '@/components/ui';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
	CircleArrowLeft,
	CircleQuestionMark,
	Mail,
	SquareAsterisk,
	SquareChevronRight,
} from 'lucide-react';
import { UserWelcomeContainer } from '@/pages/user';

// need to create a valid schema to the code based on the created pattern
const schema = z.object({
	code: z.string().max(255, 'Email inválido'),
});

type FormData = z.infer<typeof schema>;

const RecoverCode = () => {
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<FormData>({
		resolver: zodResolver(schema),
	});

	const iconCommonClass = 'w-4 h-4 text-zinc-500';

	const onSubmit = async (data: FormData) => {
		console.log(data);
		navigate('/recuperar-senha/recuperar');
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex h-full w-full flex-col items-center justify-center space-y-6 overflow-hidden overflow-y-auto px-4 py-6 md:w-1/2 md:max-w-none md:space-y-8 md:p-4"
		>
			<UserWelcomeContainer
				title="Recuperar senha"
				subtitle="Insira o código enviado para o seu e-mail"
			/>
			<div className="mx-auto flex w-full max-w-96 flex-col gap-4">
				<InputWrapperAuth
					label="Código de recuperação"
					icon={<SquareAsterisk className={iconCommonClass} />}
					error={errors.code?.message}
					value={watch('code')}
					displayError
				>
					<Input
						{...register('code')}
						placeholder="Digite o código"
					/>
				</InputWrapperAuth>
			</div>
			<div className="mx-auto w-full max-w-96">
				<Button
					className="w-full justify-center rounded-lg py-2"
					text="Enviar"
					endIcon={
						<Mail className="h-fit w-4 text-light transition-all ease-in group-hover:translate-x-1" />
					}
				/>
				<div className="mx-auto w-full">
					<div className="relative flex items-center py-3">
						<div className="flex-grow border-t border-gray-300"></div>
						<span className="mx-4 flex-shrink text-sm text-dark">
							Não recebeu o código no Email?
						</span>
						<div className="flex-grow border-t border-gray-300"></div>
					</div>
				</div>
				<Button
					type="button"
					variant="outline"
					className="w-full justify-center rounded-lg py-2"
					text="Reenviar o código"
					endIcon={
						<SquareChevronRight className="h-fit w-4 text-zinc-500 transition-all ease-in group-hover:translate-x-1" />
					}
				/>
			</div>
			<div className="mx-auto flex flex-col items-center gap-2 rounded-lg p-4 md:w-96">
				<label
					htmlFor="button-question"
					className="text-dar font-light"
				>
					Tem alguma dúvida?
				</label>
				<div className="flex items-center gap-1">
					<CircleQuestionMark className="size-4 text-cyan-950" />
					<button
						name="button-question"
						className="border-0 border-b border-solid border-cyan-950 leading-3 text-cyan-950 focus:outline-none"
					>
						Central de ajuda
					</button>
				</div>
			</div>
			<div className="mx-auto w-96">
				<Button
					startIcon={<CircleArrowLeft className="size-4 text-dark" />}
					variant="text"
					text="voltar"
					className="w-fit justify-center self-start text-base"
					onClick={() => navigate(-1)}
				/>
			</div>
		</form>
	);
};

export { RecoverCode };
